import axios from '@/libs/axios'
import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'

export default {
  async getDataEvaluateForIndividualOrganization(params) {
    try {
      const response = await axios.get(`surveys/getDataEvaluateForIndividualOrganization`, { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
  },
  async createIndividualOrganizationEvaluate(params) {
    try {
      const response = await axios.post(`surveys/createIndividualOrganizationEvaluate`, params)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  async updateIndividualOrganizationEvaluate(params) {
    try {
      const response = await axios.put(`surveys/updateIndividualOrganizationEvaluate/${params.id}`, params)
      const { data } = response
      return { isSuccessful: data.code === ApiCode.SUCCESS, message: data.message }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  async getIndividualOrganizationEvaluate(params) {
    try {
      const response = await axios.get(`surveys/getIndividualOrganizationEvaluate`, { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
  },
}
